import { createContext, useState, useContext } from 'react';

const BannerHeightContext = createContext();

export const useBannerHeight = () => useContext(BannerHeightContext);

export const BannerHeightProvider = ({ children }) => {
  const [emergencyBannerHeight, setEmergencyBannerHeight] = useState(0);
  const [developmentBannerHeight, setDevelopmentBannerHeight] = useState(0);

  const updateEmergencyBannerHeight = (height) => {
    setEmergencyBannerHeight(height);
  };

  const updateDevelopmentBannerHeight = (height) => {
    setDevelopmentBannerHeight(height);
  };
  const emergencyMapBoxPadding =
    8 +
    (emergencyBannerHeight > 0 ? 4 : 0) +
    (developmentBannerHeight > 0 ? 4 : 0);
  const defaultPageBoxPadding =
    10 +
    (emergencyBannerHeight > 0 ? 4 : 0) +
    (developmentBannerHeight > 0 ? 4 : 0);

  return (
    <BannerHeightContext.Provider
      value={{
        emergencyBannerHeight,
        developmentBannerHeight,
        defaultPageBoxPadding,
        emergencyMapBoxPadding,
        updateEmergencyBannerHeight,
        updateDevelopmentBannerHeight,
      }}
    >
      {children}
    </BannerHeightContext.Provider>
  );
};
